import React, { FC, ReactElement } from 'react'
import styles from './Modal.module.css'

import MuiModal from '@mui/material/Modal'
import classNames from 'classnames'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

// this modal is sized based on its contents and fits on mobile automatically
// the old modal uses flex and a max-width in its container class so its not as reusable
// instead of updating the existing modal and breaking all existing modals I created modal-v2
const Modal: FC<{
	open: boolean
	onClose: (evt?: any) => void
	children?: React.ReactNode
	className?: string
	bodyClassName?: string
	ariaLabel?: string
}> = (props): ReactElement => {
	const { className, bodyClassName } = props
	return (
		<MuiModal
			open={props.open}
			onClose={props.onClose}
			slotProps={{ backdrop: { classes: { root: styles.backdrop } } }}
			className={styles.modal}
		>
			<div
				className={classNames({ [props.className as any]: !!className }, styles.root)}
				onClick={props.onClose}
				role={props.ariaLabel ? 'presentation' : 'button'}
				tabIndex={props.ariaLabel ? undefined : 0}
				onKeyDown={props.ariaLabel ? undefined : onKeyboardClick(props.onClose)}
			>
				<div
					onClick={(evt) => {
						evt.stopPropagation()
					}}
					className={classNames({ [props.bodyClassName as any]: !!bodyClassName }, styles.body)}
					role={props.ariaLabel ? 'dialog' : 'button'}
					aria-modal={props.ariaLabel ? true : undefined}
					aria-label={props.ariaLabel}
					tabIndex={props.ariaLabel ? -1 : 0}
					onKeyDown={props.ariaLabel ? undefined : onKeyboardClick((evt) => {
						evt.stopPropagation()
					})}
				>
					{props.children}
				</div>
			</div>
		</MuiModal>
	)
}

export default Modal
